import { html, LitElement } from 'lit-element';

import { processEscapedMarkup } from '../../utils.js';

export const getIcon = (correct, asString) => {
  if (asString) {
    return correct ? '&#10004;' : '&#10006;';
  }

  return correct ? html`&#10004;` : html`&#10006;`;
};

/**
 * @element response-modal-ecr
 * @prop {Object} response - Response
 */
export class ResponseModalECR extends LitElement {
  static get properties() {
    return {
      response: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { sessionData, item } = this.response || {};
    const { choices, markup } = item || {};
    const { value = {} } = sessionData || {};

    if (!value || !markup || !choices) return '';

    const text = processEscapedMarkup(markup);

    const textValue = text.replace(/\{\{(.)\}\}/g, (match, group) => {
      const isCorrect =
        choices[group] && choices[group].find(ch => ch.label === value[group]);

      return `
        <span class='answer underlined margins ecr-${
          isCorrect ? 'correct' : 'incorrect'
        }-answer'>
        ${value[group] || '_____'}
        <span class='correctness-indicator'>${getIcon(isCorrect, true)}</span>
        </span>`;
    });

    return html`<div class="modal-response-content">
      <math-rendering-element .label=${textValue}></math-rendering-element>
    </div>`;
  }
}

export default ResponseModalECR;
